export var DEFAULT_REPORT_DOMAIN = "" + process.env.SLARDAR_DOMAIN_HOST;
export var DEFAULT_REPORT_BATCH_PATH = '/monitor_microapp/collect';
export var DEFAULT_SETTINGS_GET_PATH = '/settings/get/microapp';
export var DEFAULT_PID = '/';
export var DEFAULT_MAX_BREADCRUMBS = 20;
export var DEFAULT_MAX_BATCH_REPORT_LENGTH = 10;
export var DEFAULT_BATCH_REPORT_WAIT = 1000;
export var ERROR_CANNOT_GET_CONTEXT_BEFORE_INIT = 'cannot get context before init';
//# sourceMappingURL=constants.js.map